(function () {
  'use strict';

  var COUNT_SELECTOR =
    '.js-collection-wishlist-count[data-product-id]';

  var BUTTON_SELECTOR =
    '.swym-add-to-wishlist-view-product[data-product-id]';

  var countCache = new Map();
  var pendingIds = new Set();
  var swatInstance = null;

  /**
   * data-product-idを文字列として取得
   */
  function getProductId(element) {
    var productId =
      element.getAttribute('data-product-id') || '';

    return String(productId)
      .replace(/^["']|["']$/g, '')
      .trim();
  }

  /**
   * 商品カード内へ表示枠を挿入
   */
  function createCountElements() {
    var buttons =
      document.querySelectorAll(BUTTON_SELECTOR);

    var productIds = [];

    buttons.forEach(function (button) {
      var productId = getProductId(button);

      if (!productId) {
        return;
      }

      var productCard =
        button.closest('.ProductItem') ||
        button.parentElement;

      if (!productCard) {
        return;
      }

      var existingElement =
        productCard.querySelector(
          '.js-collection-wishlist-count' +
          '[data-product-id="' + productId + '"]'
        );

      if (!existingElement) {
        var countElement =
          document.createElement('div');

        countElement.className =
          'wishlist-count js-collection-wishlist-count';

        countElement.setAttribute(
          'data-product-id',
          productId
        );

        countElement.hidden = true;

        countElement.innerHTML =
        '<span class="wishlist-count__number">0</span>';

        button.insertAdjacentElement(
            'afterend',
            countElement
            );
      }

      productIds.push(productId);
    });

    return Array.from(new Set(productIds));
  }

  /**
   * 該当商品すべての表示を更新
   */
  function displayCount(productId, count) {
    var normalizedCount =
      Number.isFinite(Number(count))
        ? Number(count)
        : 0;

    var formattedCount =
      normalizedCount.toLocaleString('ja-JP');

    var elements = document.querySelectorAll(
      COUNT_SELECTOR +
      '[data-product-id="' + productId + '"]'
    );

    elements.forEach(function (element) {
      var numberElement =
        element.querySelector(
          '.wishlist-count__number'
        );

      if (numberElement) {
        numberElement.textContent = formattedCount;
      }

      /*
       * 0件も表示する
       */
      element.hidden = false;
    });
  }

  /**
   * 配列を10件ずつに分割
   */
  function splitIntoBatches(array, batchSize) {
    var batches = [];

    for (
      var index = 0;
      index < array.length;
      index += batchSize
    ) {
      batches.push(
        array.slice(index, index + batchSize)
      );
    }

    return batches;
  }

  /**
   * Swymからお気に入り数を取得
   */
  function fetchCounts(productIds) {
    if (
      !swatInstance ||
      !swatInstance.wishlist ||
      typeof swatInstance.wishlist
        .getSocialCountBatch !== 'function'
    ) {
      return;
    }

    var missingIds = productIds.filter(
      function (productId) {
        if (countCache.has(productId)) {
          displayCount(
            productId,
            countCache.get(productId)
          );

          return false;
        }

        return !pendingIds.has(productId);
      }
    );

    if (!missingIds.length) {
      return;
    }

    missingIds.forEach(function (productId) {
      pendingIds.add(productId);
    });

    var batches =
      splitIntoBatches(missingIds, 10);

    batches.forEach(function (batch) {
      swatInstance.wishlist.getSocialCountBatch(
        batch,

        function (response) {
          var items =
            response &&
            Array.isArray(response.data)
              ? response.data
              : [];

          items.forEach(function (item) {
            var productId =
              String(item.empi);

            var count =
              Number(item.count || 0);

            countCache.set(productId, count);
            pendingIds.delete(productId);

            displayCount(productId, count);
          });

          /*
           * 応答に含まれなかったIDは
           * エラーと区別するため非表示のままにする
           */
          batch.forEach(function (productId) {
            pendingIds.delete(
              String(productId)
            );
          });
        },

        function (error) {
          batch.forEach(function (productId) {
            pendingIds.delete(
              String(productId)
            );
          });

          console.error(
            'Swym一覧お気に入り数取得エラー:',
            error
          );
        }
      );
    });
  }

  /**
   * 初回・Boost再描画後の共通処理
   */
  function initializeCounts() {
    var productIds = createCountElements();

    if (productIds.length) {
      fetchCounts(productIds);
    }
  }

  /**
   * Boostから呼び出す公開関数
   */
  window.initCollectionWishlistCounts =
    function () {
      window.setTimeout(
        initializeCounts,
        0
      );
    };

  /**
   * Swymがすでに読み込まれている場合
   */
  if (
    window._swat &&
    window._swat.wishlist &&
    typeof window._swat.wishlist
      .getSocialCountBatch === 'function'
  ) {
    swatInstance = window._swat;
    window.initCollectionWishlistCounts();
  } else {
    /*
     * Swymの読み込み完了を待つ
     */
    window.SwymCallbacks =
      window.SwymCallbacks || [];

    window.SwymCallbacks.push(
      function (swat) {
        swatInstance = swat;
        window.initCollectionWishlistCounts();
      }
    );
  }

  /**
   * Swymより先にDOMが完成した場合にも対応
   */
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      window.initCollectionWishlistCounts();
    }
  );
})();